import React, { useState, useEffect } from 'react';
import styles from './stageDetailsConfiguration.module.scss';
import { Form, Button, Badge, Row, Col } from 'react-bootstrap';
import { CustomButton } from '../../../../../shared/customButton';
import { CustomDropdown } from '../../../../../shared/customDropdown';
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomTextArea } from '../../../../../shared/customTextArea';
import makeAnimated from 'react-select/animated';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import Select from 'react-select'
import * as yup from 'yup';
import { Formik } from 'formik';
import { CustomSwitchButtonRow } from '../../../../../shared/customSwitchButtonRow';
import { CustomSwitch } from '../../../../../shared/customSwitch';
import { Editor } from "react-draft-wysiwyg";
import { getAllReviewers } from '../../../../../../services/util/userManagement';
import { EditorState, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { getQuizDetailsToPiplelineStages } from '../../../../../../services/util/quizTemplates';
import { getOneWayInterviewDetailsToPipelineStages } from '../../../../../../services/util/oneWayInterviewTemplates';
import { useParams, useNavigate } from 'react-router-dom';
import {CustomAlertBox} from '../../../../../shared/customAlertBox'
import { CustomTextEditor } from '../../../../../shared/customTextEditor';

const StageDetailsConfiguration = (props) => {

    let [stageType, setStageType] = useState(props.values.stageType);
    const animatedComponents = makeAnimated();
    let [options, setOptions] = useState([]);
    let [quizTemplateOptions, setQuizTemplateOptions] = useState([]);
    let [interviewTemplateOptions, setInterviewTemplateOptions] = useState([]);
    let [isAutoAssigningAssignment, setAutoAssessmentAssigned] = useState(props.values.is_auto_assigning_assignment);
    let [quizTemplateName, setQuizTemplateName] = ('');
    let [quizTemplateLinkData, setquizTemplateLinkData] = useState('');
    let [interviewTemplateName, setInterviewTemplateName] = ('');
    let [interviewTemplateLinkData, setinterviewTemplateLinkData] = useState('');
    let [isRefernceEmailAutoSend, setRefernceEmailAutoSend] = useState(props.values.is_auto_request_referee_details_from_candidate_enabled);


    let contentState = '';
    let [assessment_body_html, set_assessment_body_html] = useState(props.values.assessment_body);

    //let assesment_assigned = isAutoAssigningAssignment; 
    const history = useNavigate();

    const dropValue = [
        {
            label: 'Auto CV Filter',
            value: 10,
        },
        {
            label: 'CV Review',
            value: 20,
        },
        {
            label: 'Interview',
            value: 30,
        },
        {
            label: 'External Assignment',
            value: 40,
        },
        {
            label: 'Quiz',
            value: 50,
        },
        {
            label: 'Reference Check',
            value: 60,
        },
        {
            label: 'Custom Evaluation',
            value: 70,
        },
        {
            label: 'One Way Interview',
            value: 80,
        },
    ]

    const reviewerCountOne = [
        {
            label: '1',
            value: 1,
        }
    ]

    const reviewerCountTwo = [
        {
            label: '1',
            value: 1,
        },
        {
            label: '2',
            value: 2,
        }
    ]

    const reviewerCountThree = [
        {
            label: '1',
            value: 1,
        },
        {
            label: '2',
            value: 2,
        },
        {
            label: '3',
            value: 3,
        },
    ]

    if (assessment_body_html) {
        const blocksFromHtml = htmlToDraft(assessment_body_html && assessment_body_html);
        const { contentBlocks, entityMap } = blocksFromHtml;
        contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    }

    const [editorState, setEditorState] = useState(
        assessment_body_html ?
            EditorState.createWithContent(contentState)
            :
            () => EditorState.createEmpty()
    );

    const [showEvaluationContent, setEvaluationShowContent] = useState(false);


    //yup validations
    const schema = yup.object({
        stageName: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        stageType: yup.string()
            .trim()
            .matches(/^[^<>=*$^]*$/, 'Remove restricted characters such as: < > = $ * ^')
            .required('Required'),
        numReviewer: yup.string()
            .when('stageType', {
                is: '20', // This checks if stageType is exactly '20'
                then:  () => yup.string()
                    .trim()
                    .matches(/^[^<>=*$^]*$/, 'Remove restricted characters such as: < > = $ * ^')
                    .required('Required'),
                otherwise:  () => yup.string().trim() // You can define a different schema for the "otherwise" case if needed
            }),
        score: yup.number().when('stageType', { is: (value) => ['20', '30', '40', '50', '70', '80'].includes(value), then: () => yup.number().min(1,'Score must be greater than or equal to 1').max(100,'Score must be less than or equal to 100').required('Required').test('is-decimal', 'Decimal point numbers are not allowed', (value) => /^\d+$/.test(value)),otherwise: () => yup.number() }),

        reviewers: yup.array().of(yup.object().shape({
            label: yup.string(),
            value: yup.string()
        })).when('stageType', { is: (value) => ['20'].includes(value), then:()=> yup.array().required('Required'), otherwise: ()=> yup.array()}),

        keywords: yup.array().of(yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^')).when('stageType', { is: (value) => ['10'].includes(value), then: ()=> yup.array().min(1, 'At least one keyword required. Enter the keyword and click "Add" button.').required(''),otherwise: () => yup.array() }),

        keywordToBeAdded: yup.string().when('stageType', { is: (value) => ['10'].includes(value), then: ()=> yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('duplicate keyword check', 'Duplicate keyword', function (item) { return !this.parent.keywords.includes(item); }) ,otherwise: () => yup.string()}),

        keywordCount: yup.number().when('stageType', { is: (value) => ['10'].includes(value), then: ()=> yup.number().test('keyword check', 'Keywords count cannot be greater than added keyword count', function (item) { return this.parent.keywords.length >= item; }).min(1, 'Should be greater than 1').required('Required'), otherwise: () => yup.number() }),

        assessment_body: yup.string().when('stageType', { is: (value) => ['40'].includes(value), then: () => yup.string().required('Required').test('email body check', 'Required', function (item) { let stripedHtml = item.replace(/<[^>]+>/g, ''); return stripedHtml.length > 0; }),  otherwise: () => yup.string()}),

        assessment_exp_date: yup.number().when('stageType', { is: (value) => ['40'].includes(value), then: () => yup.number().required('Required').integer('Invalid input').moreThan(0, 'Invalid input'), otherwise: () => yup.number()}),

        quiz_exp_date: yup.number().when('stageType', { is: (value) => ['50'].includes(value), then: () => yup.number().required('Required').moreThan(0, 'Invalid input').test('is-decimal', 'Decimal point numbers are not allowed', (value) => /^\d+$/.test(value)),  otherwise: () => yup.number()}),

        quiz_template: yup.object().shape({
            label: yup.string(),
            value: yup.string()
        }).when('stageType', { is: (value) => ['50'].includes(value), then: ()=> yup.object().required('Required'), otherwise: ()=> yup.object().nullable()}),

        assessment_reviewers: yup.object().shape({
            label: yup.string(),
            value: yup.string()
        }).when('stageType', { is: (value) => ['40'].includes(value), then: () =>yup.object().required('Required'), otherwise: ()=> yup.object().nullable() }),

        reference_check_reviewers: yup.object().shape({
            label: yup.string(),
            value: yup.string()
        }).when('stageType', { is: (value) => ['60'].includes(value), then: () =>yup.object().required('Required'),otherwise: ()=> yup.object().nullable() }),

        min_no_of_references_required: yup.number().when('stageType', { is: (value) => ['60'].includes(value), then: () => yup.number().min(1, 'Minimum number of references required must be greater than or equal to 1').max(4,'Maximum number of refernces must be 4' ).required('Required').test('is-decimal', 'Decimal point numbers are not allowed', (value) => /^\d+$/.test(value)),otherwise: () => yup.number() }),

        custom_evaluation_reviewers: yup.object().shape({
            label: yup.string(),
            value: yup.string()
        }).when('stageType', { is: (value) => ['70'].includes(value), then: () => yup.object().required('Required'),otherwise: ()=> yup.object().nullable() }),

        vacancyDesc: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^'),
        guide_for_candidates: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^'),
        guidelineDescription: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').nullable(),

        evaluationDescription: yup.string().when('stageType', { is: (value) => ['70'].includes(value), then: () => yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'), otherwise: () => yup.string() }),

        one_way_interview_reviewers: yup.object().shape({
            label: yup.string(),
            value: yup.string()
        }).when('stageType', { is: (value) => ['80'].includes(value), then: ()=> yup.object().required('Required'),otherwise: () => yup.object().nullable() }),

        interview_exp_in: yup.number().when('stageType', { is: (value) => ['80'].includes(value), then: ()=> yup.number().required('Required').integer('Invalid input').moreThan(0, 'Invalid input'), otherwise: () => yup.number() }),

        one_way_interview_template: yup.object().shape({
            label: yup.string(),
            value: yup.string()
        }).when('stageType', { is: (value) => ['80'].includes(value), then: () => yup.object().required('Required'), otherwise: ()=> yup.object().nullable() }),
    });

    const setquizLinkValues = (value) => {

        setQuizTemplateName();
    }

    //one way interview template
    const setinterviewLinkValues = (value) => {

        setInterviewTemplateName();
    }


    //on submit function
    const onSubmit = async (values) => {
        if (props.currentDropValue > props.noOfReviewers) {
            values.numReviewer = 1;
            props.setSubmitValues(values)
            props.nextPage(2)
        } else {
            props.setSubmitValues(values)
            props.nextPage(2)
        }

    }


    useEffect(() => {
        async function setReviwers() {
            let reviewesList = await getAllReviewers();
            setOptions(reviewesList.data)


            let quizTemplateList = await getQuizDetailsToPiplelineStages();
            let interviewTemplateList = await getOneWayInterviewDetailsToPipelineStages();

            setQuizTemplateOptions(quizTemplateList.data);
            setInterviewTemplateOptions(interviewTemplateList.data);
        }
        setReviwers();
    }, []);

    const removeTextDecoration = (htmlContent) => {
        let noDecoration = htmlContent.replace(/<span style="text-decoration: (underline|line-through|overline);[^>]*>(.*?)<\/span>/gi, '$2');
        noDecoration = noDecoration.replace(/<span style="background-color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        noDecoration = noDecoration.replace(/<span style="color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        let withFont = noDecoration.replace(/(<span[^>]*>)(<\/span>)/gi, (match, opening, closing) => {
            if (opening) {
                return opening + ' style="font-family: Inter, sans-serif; font-size: 12px;"';
            } else {
                return closing;
            }
        });
        // Set font family and size to Inter, sans-serif; font-size: 16px for <h3> tags
        withFont = withFont.replace(/<h3[^>]*>(.*?)<\/h3>/gi, (match, content) => {
            return `<h3 style="font-family: Inter, sans-serif; font-size: 16px !important;">${content}</h3>`;
        });
        
        return withFont;
    };


    return (
        <div>
            <Formik
                enableReinitialize
                validationSchema={schema}
                onSubmit={(values) => { onSubmit(values) }}
                initialValues={{ stageName: props.values.stageName, stageType: props.values.stageType, vacancyDesc: props.values.description, numReviewer: props.values.numReviewer, reviewers: props.values.reviewers, assessment_reviewers: props.values.assessment_reviewers, score: props.values.score, keywords: props.values.keywords, keywordToBeAdded: props.values.keywordToBeAdded, keywordCount: props.values.keywordCount, guidelineDescription: props.values.interview_guidelines_to_candidate, assessment_body: props.values.assessment_body, assessment_exp_date: props.values.assessment_exp_date, quiz_template: props.values.quiz_template, quiz_exp_date: props.values.quiz_exp_date, reference_check_reviewers: props.values.reference_check_reviewers, min_no_of_references_required: props.values.min_no_of_references_required ? props.values.min_no_of_references_required : 1, guide_for_candidates: props.values.guide_for_candidates, custom_evaluation_reviewers: props.values.custom_evaluation_reviewers, evaluationDescription: props.values.custom_evaluation_description, one_way_interview_reviewers: props.values.one_way_interview_reviewers, interview_exp_in: props.values.interview_exp_in, one_way_interview_template: props.values.one_way_interview_template , is_auto_request_referee_details_from_candidate_enabled: props.is_auto_request_referee_details_from_candidate_enabled}}>

                {({
                    values,
                    errors,
                    setFieldValue,
                    handleChange,
                    handleSubmit,
                    submitCount,
                    setFieldError
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>

                        <CustomTextField
                            label="Stage Name"
                            name="stageName"
                            classLabel="defaultLabel"
                            controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_stageNameFieldId"
                            type="text"
                            placeholder="ex:- Technical CV Review Step"
                            value={values.stageName}
                            classType="defaultTextBox"
                            handleOnChange={handleChange}
                            errorMessage={errors.stageName}
                            validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_stageNameValidationMsgId"
                            isInvalid={submitCount > 0 && !!errors.stageName}
                        />
                        <CustomDropdown
                            label="Stage Type"
                            controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_stageTypeDropDownFieldId"
                            name="stageType"
                            value={values.stageType}
                            handleOnChange={(e) => { setFieldValue('stageType', parseInt(e.target.value)); setStageType(parseInt(e.target.value)) }}
                            dropdownValues={dropValue}
                            errorMessage={errors.stageType}
                            validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_stageTypeValidationMsgId"
                            hiddenOption="Select Stage Type"
                            isInvalid={submitCount > 0 && !!errors.stageType}
                        />                
                            <div className="mt-1">
                                {stageType === 10 &&<CustomAlertBox isExternalLinkAvailable={true} alertBodyText="Auto CV Filter Step" alertType="defaultAlert" externalLink='https://hiretrace.io/documentation/automated-cv-filters/overview' externalLinkLable='Learn more'/>}
                                {stageType === 20 &&<CustomAlertBox isExternalLinkAvailable={true} alertBodyText="CV Review Step" alertType="defaultAlert" externalLink='https://hiretrace.io/documentation/cv-reviews/overview' externalLinkLable='Learn more'/>}
                                {stageType === 30 &&<CustomAlertBox isExternalLinkAvailable={true} alertBodyText="You can assign interviewers for each interview session when scheduling interviews." alertType="defaultAlert" externalLink='https://hiretrace.io/documentation/interviews/overview' externalLinkLable='Learn more'/>}
                                {stageType === 40 &&<CustomAlertBox isExternalLinkAvailable={true} alertBodyText="External Assignment Step" alertType="defaultAlert" externalLink='https://hiretrace.io/documentation/external-assessments/overview' externalLinkLable='Learn more'/>}
                                {/* {stageType === 60 && <p className={styles.documentLink}  ><a href='https://hiretrace.io/documentation/external-assessments/overview' target="_blank">Learn more about <span className={styles.focuedDocumentLinkText}>Reference Check</span> Stages <i class="fas fa-external-link-alt"></i></a></p>} */}


                                {(stageType === 20) &&
                                    <div className='mt-1'>
                                        <Form.Label className={styles.reviewerLabel}>
                                            Reviewers &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{stageType === 20 ? <p>During the evaluation, candidate CVs will be automatically and randomly distributed among the selected reviewers.</p> : stageType === 40 ? <p>During the evaluation, candidate Assignment will be automatically distributed among the selected reviewers.</p> : null}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <p className={styles.reviewersNotice}>Go to "Manage Users" and add users to the account before selecting reviewers</p>
                                        <Select options={options}
                                            isMulti
                                            className={styles.selctText}
                                            name="reviewers"
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={values.reviewers}
                                            onChange={(e) => {
                                                if (e && e.length > 3) {
                                                    setFieldError('reviewers', 'You can select a maximum of 3 reviewers.');
                                                    return;
                                                }
                                                setFieldValue('reviewers', e);
                                                props.setNumReviewers(e ? e.length : 0);
                                            }}
                                            getOptionValue={option => `${option._id}`}
                                            getOptionLabel={options => `${options.user_id.email} - ${options.user_id.first_name} ${options.user_id.last_name}`}
                                            styles={
                                                errors.reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                    {errors.reviewers &&
                                        <p className={styles.errorMsg} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_reviewersValidationMsgId">{errors.reviewers}</p>
                                    }
                                </div>
                                }
                                {(stageType === 40) &&
                                    <div className='mt-1'>
                                        <Form.Label className={styles.reviewerLabel}>
                                            Reviewer &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{<p>During the evaluation, candidate Assignment will be automatically distributed to the selected reviewer.</p>}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <p className={styles.reviewersNotice}>Go to "Manage Users" and add users to the account before selecting reviewers</p>
                                        <Select options={options}
                                            className={styles.selctText}
                                            name="assessment_reviewers"
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={values.assessment_reviewers}
                                            onChange={(e) => { setFieldValue('assessment_reviewers', e); props.setNumReviewers(e && e.length) }}
                                            getOptionValue={option => `${option._id}`}
                                            getOptionLabel={options => `${options.user_id.email} - ${options.user_id.first_name} ${options.user_id.last_name}`}
                                            styles={
                                                errors.assessment_reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                    {errors.assessment_reviewers &&
                                        <p className={styles.errorMsg} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_reviewerValidationMsgId">{errors.assessment_reviewers}</p>
                                    }
                                    </div>
                                }

                                {(stageType === 60) &&
                                    <div>
                                        <Form.Label className={styles.reviewerLabel}>
                                            Reviewer &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{<p>During the evaluation, candidate profile will be automatically distributed among the selected reviewer to check references.</p>}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <p className={styles.reviewersNotice}>Go to "Manage Users" and add users to the account before selecting reviewers</p>
                                        <Select options={options}
                                            className={styles.selctText}
                                            name="reference_check_reviewers"
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={values.reference_check_reviewers}
                                            onChange={(e) => { setFieldValue('reference_check_reviewers', e); props.setNumReviewers(e && e.length) }}
                                            getOptionValue={option => `${option._id}`}
                                            getOptionLabel={options => `${options.user_id.email} - ${options.user_id.first_name} ${options.user_id.last_name}`}
                                            styles={
                                                errors.reference_check_reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                        <p className={styles.errorMsg} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_reviewerValidationMsgId">{errors.reference_check_reviewers}</p>

                                    </div>
                                }

                                {(stageType === 70) &&
                                    <div>
                                        <Form.Label className={styles.reviewerLabel}>
                                            Reviewer &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{<p>During the evaluation, candidate profile will be automatically distributed among the selected reviewer to check custom evaluation.</p>}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <p className={styles.reviewersNotice}>Go to "Manage Users" and add users to the account before selecting reviewers</p>
                                        <Select options={options}
                                            className={styles.selctText}
                                            name="custom_evaluation_reviewers"
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={values.custom_evaluation_reviewers}
                                            onChange={(e) => { setFieldValue('custom_evaluation_reviewers', e); props.setNumReviewers(e && e.length) }}
                                            getOptionValue={option => `${option._id}`}
                                            getOptionLabel={options => `${options.user_id.email} - ${options.user_id.first_name} ${options.user_id.last_name}`}
                                            styles={
                                                errors.custom_evaluation_reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                    {errors.custom_evaluation_reviewers &&
                                        <p className={styles.errorMsg}>{errors.custom_evaluation_reviewers}</p>
                                    }
                                    </div>
                                }

                                {(stageType === 80) &&
                                    <div>
                                        <Form.Label className={styles.defaultLabelSec}>
                                            Select Interview Template&nbsp;
                                            <svg data-tooltip-id={`reviewersListInterviewTemplate`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersListInterviewTemplate`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{<p>During the evaluation, candidates will get assigned answer the questions in the selected template.</p>}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <p className={styles.reviewersNotice}>If you don't see any options here, go to "<span className={styles.documentLink} onClick={() => { history(`/company/templates/one-way-interview-templates`) }}  ><span className={styles.quizTemplateLink}>Interview Templates</span>
                                        </span>" and create interview templates and activate them.</p>

                                        <Select options={interviewTemplateOptions}
                                            className={styles.selctText}
                                            name="one_way_interview_template"
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={values.one_way_interview_template}
                                            onChange={(e) => { setFieldValue('one_way_interview_template', e); setinterviewTemplateLinkData(e); }}
                                            //props.setNumReviewers(e && e.length)
                                            getOptionValue={option => `${option.one_way_interview_template_id}`}
                                            getOptionLabel={option => `${option.template_name} `}
                                            styles={
                                                errors.one_way_interview_template === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                    {errors.one_way_interview_template &&
                                        <p className={styles.errorMsg} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_selectOneWayInterviewTemplateValidationMsgId">{errors.one_way_interview_template}</p>
                                    }
                                    </div>

                                }

                                {(stageType === 80) &&
                                <div className='mt-2'>
                                    <Form.Label className={styles.defaultLabelSec}>
                                        Reviewer &nbsp;
                                        <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>During the evaluation, candidate interview will be automatically distributed among the selected reviewer.</p>}</div>
                                        </ReactTooltip>
                                    </Form.Label>
                                    <p className={styles.reviewersNotice}>Go to "Manage Users" and add users to the account before selecting reviewers</p>
                                    <Select options={options}
                                        className={styles.selctText}
                                        name="one_way_interview_reviewers"
                                        class="react-select__control"
                                        components={animatedComponents}
                                        value={values.one_way_interview_reviewers}
                                        onChange={(e) => { setFieldValue('one_way_interview_reviewers', e); props.setNumReviewers(e && e.length) }}
                                        getOptionValue={option => `${option._id}`}
                                        getOptionLabel={options => `${options.user_id.email} - ${options.user_id.first_name} ${options.user_id.last_name}`}
                                        styles={
                                            errors.one_way_interview_reviewers === 'Required' ?
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                        border: '1px solid #dc3545', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                }
                                                :
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                        border: '1px solid #bdbdbd', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                    multiValue: (styles) => {
                                                        return {
                                                            ...styles,
                                                            background: 'rgba(45, 166, 192, 0.1)',
                                                        };
                                                    },
                                                    multiValueLabel: (styles) => ({
                                                        ...styles,
                                                        color: '#24859A',
                                                    }),
                                                    multiValueRemove: (styles) => ({
                                                        ...styles,
                                                        color: '#24859A',
                                                        ':hover': {
                                                            backgroundColor: '#24859A',
                                                            color: 'white',
                                                        },
                                                    }),
                                                }
                                        }
                                    />
                                    {errors.one_way_interview_reviewers &&
                                        <p className={styles.errorMsg} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_oneWayInterviewReviewerValidationMsgId">{errors.one_way_interview_reviewers}</p>
                                    }
                                </div>
                                }

                                {(stageType === 20) &&
                                    <div className='mt-1'>
                                        <CustomDropdown
                                            label="Number of Reviewers Per CV"
                                            labelToolTip="How many reviewers should be assigned to evaluate one candidate CV."
                                            labelToolTipId="numOfReviewersPerCV"
                                            controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_numOfReviewersPerCVFieldId"
                                            name="numReviewer"
                                            value={values.numReviewer}
                                            handleOnChange={(e) => { setFieldValue('numReviewer', parseInt(e.target.value)); props.setDropValue(e.target.value) }}
                                            dropdownValues={props.noOfReviewers === 1 ? reviewerCountOne : props.noOfReviewers === 2 ? reviewerCountTwo : props.noOfReviewers === 3 ? reviewerCountThree : reviewerCountOne}
                                            errorMessage={errors.numReviewer}
                                            isInvalid={submitCount > 0 && !!errors.numReviewer}
                                        />
                                    </div>
                                }
                                {(stageType === 50) &&
                                    <div>
                                        <Form.Label className={styles.defaultLabelSec}>
                                            Select Quiz Template&nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{<p>During the evaluation, candidates will get assigned answer the questions in the selected template.</p>}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <p className={styles.reviewersNotice}>If you don't see any options here, go to "<span className={styles.documentLink} onClick={() => { history(`/company/templates/quiz-templates`) }}  ><span className={styles.quizTemplateLink}>Quiz Templates</span>
                                        </span>" and create quiz templates and activate them.</p>

                                        <Select options={quizTemplateOptions}
                                            className={styles.selctText}
                                            name="quiz_template"
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={values.quiz_template}
                                            onChange={(e) => { setFieldValue('quiz_template', e); setquizTemplateLinkData(e); }}
                                            //props.setNumReviewers(e && e.length)
                                            getOptionValue={option => `${option.quiz_template_id}`}
                                            getOptionLabel={option => `${option.name} `}
                                            styles={
                                                errors.quiz_template === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                    {errors.quiz_template &&
                                        <p className={styles.errorMsg} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_selectQuizTemplateValidationMsgId">{errors.quiz_template}</p>
                                    }
                                    </div>

                                }

                                {(stageType === 60) &&
                                    <div>
                                        <Form.Group>
                                            <div>
                                                <p className={styles.defaultLabelSec}>Minimum Number of References Required&nbsp;
                                                    <svg data-tooltip-id={`interviewExpireTime`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                    <ReactTooltip id={`interviewExpireTime`} place="right" type="dark" effect="solid" clickable={true}>
                                                        <div className={styles.toolTipBox}>{<p>Number of reference candidates needed to be added.</p>}</div>
                                                    </ReactTooltip> </p>
                                            </div>

                                            <div >
                                                <Row className={styles.toggleContainer}>
                                                    <Col>
                                                        <CustomTextField                                                
                                                            name="min_no_of_references_required"
                                                            placeholder="2"
                                                            classLabel="defaultLabel"
                                                            controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_addMinimumNumberOfReferencesFieldId"
                                                            type="number"
                                                            value={values.min_no_of_references_required}
                                                            classType="defaultTextBox"
                                                            handleOnChange={handleChange}
                                                            errorMessage={errors.min_no_of_references_required}
                                                            isInvalid={submitCount > 0 && !!errors.min_no_of_references_required}
                                                        />
                                                    </Col>
                                                </Row>


                                            </div>
                                        </Form.Group>
                                    <div className='mt-3'>
                                        <CustomAlertBox alertBodyText="If you turn on this feature, HireTrace will automatically request referee information from candidates when they reach this stage. Keep it OFF, if you want to check references only on selected candidates" alertType="defaultAlert" />
                                        <div className={styles.autoEmailTogle}>
                                            <p className={styles.defaultLabel}>Request Referee Details Automatically&nbsp;</p>
                                            <span className='ms-3 mt-2 d-flex  align-items-center'>
                                                <CustomSwitch
                                                    classType={isRefernceEmailAutoSend ? "animateSwitchActive" : "animateSwitch"}
                                                    handleChange={(e) => { setFieldValue('is_auto_request_referee_details_from_candidate_enabled', !isRefernceEmailAutoSend); setRefernceEmailAutoSend(!isRefernceEmailAutoSend); }}
                                                    isChecked={isRefernceEmailAutoSend}
                                                />
                                            </span>
                                        </div>
                                    </div>

                                </div>

                                }

                                {(stageType === 20 || stageType === 30 || stageType === 40 || stageType === 50 || stageType === 60 || stageType === 70 || stageType === 80) &&
                                    <div>
                                        {(stageType != 60) &&
                                        <div className='mt-1'>
                                            <CustomTextField
                                                label="Minimum Pass Score (%)"
                                                labelToolTip="The minimum score that candidates should receive in order to pass from this evaluation stage. Enter a percentage value."
                                                labelToolTipId="minimumPassScore"
                                                name="score"
                                                placeholder="ex:- 75"
                                                classLabel="defaultLabel"
                                                controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_minimumPassScoreFieldId"
                                                type="number"
                                                value={values.score}
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                errorMessage={errors.score}
                                                validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_minimumPassScoreValidationMsgId"
                                                isInvalid={submitCount > 0 && !!errors.score}
                                            />
                                        </div>}
                                        {(stageType != 50) &&

                                            <Form.Group controlId="exampleForm.ControlTextarea1">
                                                <Form.Label className={styles.textareaLabel}>
                                                    Guideline For Reviewers &nbsp;
                                                    <svg data-tooltip-id={`reviewersCriteria`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                    <ReactTooltip id={`reviewersCriteria`} place="right" type="dark" effect="solid" clickable={true}>
                                                        <div className={styles.toolTipBox}>{stageType === 20 ? <p> A guideline for reviewers to evaluate candidate CVs.</p> : stageType === 60 ? <p> A guideline for reviewers to evaluate candidate references.</p> : stageType === 70 ? <p> A guideline for reviewers to evaluate candidate custom evaluations</p> : <p>A guideline for interviewers to evaluate candidates.</p>}</div>
                                                    </ReactTooltip>

                                                </Form.Label>

                                                {/* <Form.Control as="textarea" name="vacancyDesc" value={values.vacancyDesc} onChange={handleChange} rows={3} className={styles.textareaBox} placeholder={stageType === 20 ? "Ex: Review candidate CVs based on technical skills. Ideal candidates should have knowledge on reactjs, nodejs, mongodb , mysql, aws, java, html." : "Ex: Evaluate candidates based on technical skills. Ideal candidates should have knowledge on reactjs, nodejs, mongodb , mysql, aws, java, html."} /> */}
                                                <CustomTextArea
                                                    name="vacancyDesc"
                                                    controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_guidelineForReviewersTextAreaId"
                                                    values={values.vacancyDesc}
                                                    errorMessage={errors.vacancyDesc}
                                                    validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_guidelineForReviewersValidationMsgId"
                                                    handleChange={handleChange}
                                                    isInvalid={submitCount > 0 && !!errors.vacancyDesc}
                                                    remainingCount={(values.vacancyDesc).length}
                                                    placeholder={stageType === 20 ? "Ex: Review candidate CVs based on technical skills. Ideal candidates should have knowledge on reactjs, nodejs, mongodb , mysql, aws, java, html." : stageType === 60 ? "Ex: Review candidate based on references." : stageType === 70 ? "Ex: Evaluate candidates based on custom evaluations." : "Ex: Evaluate candidates based on technical skills. Ideal candidates should have knowledge on reactjs, nodejs, mongodb , mysql, aws, java, html."}
                                                // maxLength={800}
                                                />

                                            </Form.Group>
                                        }
                                    </div>
                                }
                                {(stageType === 60) &&
                                    <div>
                                        <Form.Group controlId="exampleForm.ControlTextarea1">
                                            <Form.Label className={styles.textareaLabel}>
                                                Guideline For Candidates &nbsp;
                                                <svg data-tooltip-id={`guide_for_candidates`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                <ReactTooltip id={`guide_for_candidates`} place="right" type="dark" effect="solid" clickable={true}>
                                                    <div className={styles.toolTipBox}>{<p>Guidelines for candidates to submit references.</p>}</div>
                                                </ReactTooltip>

                                            </Form.Label>

                                            <CustomTextArea
                                                name="guide_for_candidates"
                                                values={values.guide_for_candidates}
                                                errorMessage={errors.guide_for_candidates}
                                                handleChange={handleChange}
                                                isInvalid={submitCount > 0 && !!errors.guide_for_candidates}
                                                placeholder="Ex: Please provide the contact details of your previous employer."
                                            />

                                        </Form.Group>
                                    </div>

                                }
                                {(stageType === 30) &&
                                    <div>
                                        <Form.Group controlId="exampleForm.ControlTextarea1">
                                            <Form.Label className={styles.textareaLabel}>
                                                Interview Guidelines&nbsp;For&nbsp;Candidates&nbsp;
                                                <svg data-tooltip-id={`interviewGuideline`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                <ReactTooltip id={`interviewGuideline`} place="right" type="dark" effect="solid" clickable={true}>
                                                    <div className={styles.toolTipBox}>{<p> A guideline for candidates to prepare for the interview.</p>}</div>
                                                </ReactTooltip>

                                            </Form.Label>


                                            {/* <Form.Control as="textarea" name="guidelineDescription" value={values.guidelineDescription} onChange={handleChange} rows={3} className={styles.textareaBox} placeholder={"Ex: This is a technical interview so get ready for technical questions."} /> */}
                                            <CustomTextArea

                                                name="guidelineDescription"
                                                values={values.guidelineDescription}
                                                controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_interviewGuidelineForCandidatesTextAreaId"
                                                errorMessage={errors.guidelineDescription}
                                                validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_interviewGuidelineForCandidatesValidationMsgId"
                                                handleChange={handleChange}
                                                isInvalid={submitCount > 0 && !!errors.guidelineDescription}
                                            // remainingCount={(values.guidelineDescription).length}
                                            // maxLength={800}
                                            />
                                        </Form.Group>
                                    </div>
                                }

                                {(stageType === 70) &&
                                    <div className='mt-1'>
                                        <Form.Group controlId="exampleForm.ControlTextarea1">
                                            <Form.Label className={styles.textareaLabel}>
                                                Custom Evaluation Description&nbsp;For&nbsp;Reviewer&nbsp;
                                                <svg data-tooltip-id={`interviewGuideline`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                <ReactTooltip id={`interviewGuideline`} place="right" type="dark" effect="solid" clickable={true}>
                                                    <div className={styles.toolTipBox}>{<p> A guideline for reviewer to how to conduct the Custom Evaluation.</p>}</div>
                                                </ReactTooltip>

                                            </Form.Label>

                                            <CustomTextArea

                                                name="evaluationDescription"
                                                values={values.evaluationDescription}
                                                controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_customEvaluationDescriptionTextAreaId"
                                                errorMessage={errors.evaluationDescription}
                                                validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_customEvaluationDescriptionValidationMsgId"
                                                handleChange={handleChange}
                                                isInvalid={submitCount > 0 && !!errors.evaluationDescription}
                                            />
                                        </Form.Group>
                                    </div>
                                }

                                {(stageType === 10) &&
                                    <div>
                                        <Form.Group className={styles.formText} controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_keywordToScanFieldId">

                                            <Form.Label
                                                className={styles.defaultLabel}>
                                                Keywords to Scan&nbsp;&nbsp;
                                                <svg data-tooltip-id={`KeyWordToScanInfo`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                <ReactTooltip id={`KeyWordToScanInfo`} place="right" type="dark" effect="solid" clickable={true}>
                                                    <div className={styles.toolTipBox}>{<p> Add keywords one by one.</p>}</div>
                                                </ReactTooltip>

                                            </Form.Label>
                                            <p className={styles.reviewersNotice}>As a best practice choose common keywords. Such as "<b>java</b>", "<b>technical writing</b>", "<b>digital marketing</b>". Do not use uncommon multiword keywords, otherwise most of the CVs will get rejected automatically.</p>
                                            <div className={styles.keywordInputFormDiv}>
                                                <Form.Control
                                                    className={styles.defaultTextBox}
                                                    name="keywordToBeAdded"
                                                    placeholder='Java'
                                                    type="text"
                                                    value={values.keywordToBeAdded || ''}
                                                    onChange={(e) => { setFieldValue('keywordToBeAdded', e.target.value.toLowerCase()) }}
                                                    isInvalid={submitCount > 0 && !!errors.keywordToBeAdded}
                                                    errorMessage={errors.keywordToBeAdded}
                                                />
                                                <Button type="button" variant="primary" className={styles.keywordAddBtn} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_keywordAddBtnId" disabled={!!errors.keywordToBeAdded} onClick={((values.keywordToBeAdded).length > 0) ? () => { values.keywords.push(values.keywordToBeAdded.toLowerCase()); setFieldValue('keywordToBeAdded', ''); } : null}>Add</Button>
                                            </div>
                                            {errors.keywordToBeAdded &&
                                                <span className={styles.errorMsg} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_keywordValidationMessageID">{errors.keywordToBeAdded}</span>
                                            }
                                            {submitCount > 0 && errors.keywords && !errors.keywordToBeAdded &&
                                                <span className={styles.errorMsg}>{errors.keywords}</span>
                                            }

                                            <Row xs="auto" className="mt-2 ms-1">
                                                {
                                                    values.keywords.map((item, i) => (
                                                        (
                                                    <Col  className="ms-0 me-0 mt-2 ps-0 pe-2">
                                                                <div className={styles.keywordbadgeDiv} key={i}>
                                                                    <Badge className={styles.keywordbadge} id={`adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_addedKeywordId.${i}`}>{item}&nbsp;&nbsp;
                                                                    <span onClick={() => { values.keywords.splice(i, 1); setFieldValue('keywords', values.keywords) }}>
                                                                        <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M10.5 3.5L3.5 10.5" stroke="#24859A" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M3.5 3.5L10.5 10.5" stroke="#24859A" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </span>
                                                                </Badge>
                                                            </div>
                                                    </Col>
                                                        )
                                                    ))
                                                }
                                            </Row>
                                        </Form.Group>

                                        <CustomTextField
                                            label="Minimum required keyword count"
                                            name="keywordCount"
                                            placeholder="ex:- 5"
                                            classLabel="defaultLabel"
                                            controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_keywordCountFielId"
                                            type="number"
                                            value={values.keywordCount}
                                            classType="defaultTextBox"
                                            handleOnChange={handleChange}
                                            errorMessage={errors.keywordCount}
                                            validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_minimumRequiredKeywordCountValidationMsgId"
                                            isInvalid={submitCount > 0 && !!errors.keywordCount}
                                        />
                                    </div>
                                }

                                {(stageType === 40) &&
                                    <div>
                                        <div>
                                        <Form.Group>
                                            <Form.Label className={styles.defaultLabel}>
                                                Assignment
                                            </Form.Label>

                                                <div className={submitCount > 0 && errors.assessment_body ? styles.emailBodyContainerError : styles.emailBodyContainer}>
                                                    <CustomTextEditor
                                                    value = {assessment_body_html}
                                                    handleOnChange = {(e) => { set_assessment_body_html(e); setFieldValue('assessment_body', removeTextDecoration(e)) }}
                                                    />
                                                </div>
                                                {submitCount > 0 && errors.assessment_body &&
                                                    <div>
                                                        <span className={styles.errorMessage} id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_assesmentValidationMsgId">
                                                            {errors.assessment_body}
                                                        </span>
                                                    </div>
                                                }

                                            </Form.Group>
                                            <Form.Group>
                                                <div>
                                                    <p className={styles.defaultLabel}>Assignment Expire After&nbsp;
                                                        <svg data-tooltip-id={`assessmentExpireTime`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                        <ReactTooltip id={`assessmentExpireTime`} place="right" type="dark" effect="solid" clickable={true}>
                                                            <div className={styles.toolTipBox}>{<p>Candidates must complete and submit the assignment within this period. Otherwise the assignment will expire and candidate will get rejected automatically</p>}</div>
                                                        </ReactTooltip> </p>
                                                </div>

                                                <div >
                                                    <Row className={styles.toggleContainer}>
                                                        <Col>

                                                            <CustomTextField
                                                                //label="Short Description about Review Criteria"
                                                                //labelToolTip="The minimum score that candidates should receive in order to pass from this evaluation stage. Enter a percentage value."
                                                                //labelToolTipId="minimumPassScore"
                                                                name="assessment_exp_date"
                                                                placeholder="ex:- 5"
                                                                classLabel="defaultLabel"
                                                                controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_assessmentExpireAfterFieldId"
                                                                type="number"
                                                                value={values.assessment_exp_date}
                                                                classType="defaultTextBox"
                                                                handleOnChange={handleChange}
                                                                errorMessage={errors.assessment_exp_date}
                                                                validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_assessmentExpireAfterValidationMsgId"
                                                                isInvalid={submitCount > 0 && !!errors.assessment_exp_date}
                                                            />

                                                        </Col>
                                                        <Col lg={1} className='mt-2 mr-3'>

                                                            <p className={styles.daysLabel}>days</p>


                                                        </Col>
                                                    </Row>


                                                </div>
                                            </Form.Group>

                                        </div>
                                    </div>
                                }

                                {(stageType === 50) &&
                                    <div>
                                        <Form.Group>
                                            <div className='mt-2'>
                                                <p className={styles.defaultLabel}>Quiz Expire After&nbsp;
                                                    <svg data-tooltip-id={`quizExpireTime`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                    <ReactTooltip id={`quizExpireTime`} place="right" type="dark" effect="solid" clickable={true}>
                                                        <div className={styles.toolTipBox}>{<p>Candidates must answer to the quiz within this period. Otherwise the quiz will expire and candidate will get rejected automatically</p>}</div>
                                                    </ReactTooltip> </p>
                                            </div>

                                            <div >
                                                <Row className={styles.toggleContainer}>
                                                    <Col>

                                                        <CustomTextField
                                                            //label="Short Description about Review Criteria"
                                                            //labelToolTip="The minimum score that candidates should receive in order to pass from this evaluation stage. Enter a percentage value."
                                                            //labelToolTipId="minimumPassScore"
                                                            name="quiz_exp_date"
                                                            placeholder="ex -5"
                                                            classLabel="defaultLabel"
                                                            controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_quizExpireAferFieldId"
                                                            type="number"
                                                            value={values.quiz_exp_date}
                                                            classType="defaultTextBox"
                                                            handleOnChange={handleChange}
                                                            errorMessage={errors.quiz_exp_date}
                                                            validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_quizExpireAfterValidationMsgId"
                                                            isInvalid={submitCount > 0 && !!errors.quiz_exp_date}
                                                        />
                                                    </Col>
                                                    <Col lg={1} className='mt-2 mr-3'>

                                                        <p className={styles.daysLabel}>days</p>

                                                 </Col>
                                                </Row>
                                            </div>
                                        </Form.Group>

                                    </div>

                                }

                                {(stageType === 80) &&
                                    <div>
                                        <Form.Group>
                                            <div>
                                                <p className={styles.defaultLabel}>Interview Expire After&nbsp;
                                                    <svg data-tooltip-id={`interviewExpireTime`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                    <ReactTooltip id={`interviewExpireTime`} place="right" type="dark" effect="solid" clickable={true}>
                                                        <div className={styles.toolTipBox}>{<p>Candidates must faced the interview within this period. Otherwise the interview will expire and candidate will get rejected automatically</p>}</div>
                                                    </ReactTooltip> </p>
                                            </div>

                                            <div >
                                                <Row className={styles.toggleContainer}>
                                                    <Col>

                                                        <CustomTextField
                                                            //label="Short Description about Review Criteria"
                                                            //labelToolTip="The minimum score that candidates should receive in order to pass from this evaluation stage. Enter a percentage value."
                                                            //labelToolTipId="minimumPassScore"
                                                            name="interview_exp_in"
                                                            placeholder="ex -5"
                                                            classLabel="defaultLabel"
                                                            controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_interviewExpireAfterId"
                                                            type="number"
                                                            value={values.interview_exp_in}
                                                            classType="defaultTextBox"
                                                            handleOnChange={handleChange}
                                                            errorMessage={errors.interview_exp_in}
                                                            validationMessageId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_interviewExpireAfterValidationMsgId"
                                                            isInvalid={submitCount > 0 && !!errors.interview_exp_in}
                                                        />



                                                    </Col>
                                                    <Col lg={1} className='mt-2 mr-3'>

                                                        <p className={styles.daysLabel}>days</p>


                                                    </Col>
                                                </Row>


                                            </div>
                                        </Form.Group>

                                    </div>

                                }
                                <hr className={styles.dividerLine} />
                                <Row className='mt-0 d-flex flex-row-reverse'>
                                <div className={styles.nexBtnDiv}>
                                    <CustomButton
                                        id="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_stepConfigurationNextBtnId"
                                        buttonType="submit"
                                        label="Next"
                                        type="primaryBtn"
                                    />
                                </div>
                                </Row>
                            </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default StageDetailsConfiguration;
